import { render, staticRenderFns } from "./FocusedClientCategory.vue?vue&type=template&id=472bb236&scoped=true"
import script from "./FocusedClientCategory.vue?vue&type=script&lang=js"
export * from "./FocusedClientCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472bb236",
  null
  
)

export default component.exports